import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AUCTION_TYPES } from '../common/auctionScrapeTypes'
import { PROPERTY_TYPES } from '../common/drmTypes'

export enum DRAWER_TYPE {
  PROPERTY = 'property',
  AUCTION = 'auction',
  LV = 'lv',
}

export enum DRAWER_VIEW {
  ASSIGNMENT_MODE = 'assignmentMode',
  DEFAULT = 'default',
}

interface DrawerState {
  [DRAWER_TYPE.PROPERTY]: {
    propertyType: PROPERTY_TYPES
    id: string
  } | null
  [DRAWER_TYPE.AUCTION]: {
    auctionType: AUCTION_TYPES
    id: string
  } | null
  [DRAWER_TYPE.LV]: {
    lvCode: string
    lvNumber: string
  } | null
  viewType: DRAWER_VIEW
}

const initialState: DrawerState = {
  [DRAWER_TYPE.PROPERTY]: null,
  [DRAWER_TYPE.AUCTION]: null,
  [DRAWER_TYPE.LV]: null,
  viewType: DRAWER_VIEW.DEFAULT,
}

const drawerSlice = createSlice({
  name: 'drawer',
  initialState,
  reducers: {
    setPropertyDrawer: (
      state,
      action: PayloadAction<{ id: string; propertyType: PROPERTY_TYPES }>
    ) => {
      state[DRAWER_TYPE.PROPERTY] = {
        propertyType: action.payload.propertyType,
        id: action.payload.id,
      }
    },
    resetPropertyDrawer: state => {
      state[DRAWER_TYPE.PROPERTY] = null
    },

    setAuctionDrawer: (
      state,
      action: PayloadAction<{ id: string; auctionType: AUCTION_TYPES }>
    ) => {
      state[DRAWER_TYPE.AUCTION] = {
        auctionType: action.payload.auctionType,
        id: action.payload.id,
      }
    },
    resetAuctionDrawer: state => {
      state[DRAWER_TYPE.AUCTION] = null
    },

    setLvDrawer: (
      state,
      action: PayloadAction<{ lvCode: string; lvNumber: string }>
    ) => {
      state[DRAWER_TYPE.LV] = {
        lvCode: action.payload.lvCode,
        lvNumber: action.payload.lvNumber,
      }
    },
    resetLvDrawer: state => {
      state[DRAWER_TYPE.LV] = null
    },

    setDrawerView: (state, action: PayloadAction<DRAWER_VIEW>) => {
      state.viewType = action.payload
    },
    resetDrawerView: state => {
      state.viewType = DRAWER_VIEW.DEFAULT
    },
  },
})

export const {
  resetPropertyDrawer,
  setPropertyDrawer,
  setAuctionDrawer,
  resetAuctionDrawer,
  setLvDrawer,
  resetLvDrawer,
  setDrawerView,
  resetDrawerView,
} = drawerSlice.actions

export default drawerSlice.reducer
